module.exports = __webpack_public_path__ + "img/logo-en.7cfc25ef.png";